// Types for recognition quality scores and top recognitions feature

export enum DimensionKey {
	Specific = 'specific',
	Contextual = 'contextual',
	ValuesAligned = 'values_aligned',
	Personal = 'personal',
	Genuine = 'genuine',
}

export type ScoredBonusAttachment = {
	gif: string;
	videoThumbnailUrl?: string;
	videoPosterUrl?: string;
};

export type QualityScoreDimension = {
	key: DimensionKey;
	matches: boolean;
	reason: string;
};

export type QualityScore = {
	dimensions: QualityScoreDimension[];
	score: number;
};

export type ScoredBonusUser = {
	id: string;
	displayName: string;
	profilePic: string;
};

export type ScoredBonus = {
	id: string;
	reason: string;
	qualityScore: QualityScore;
	attachments: ScoredBonusAttachment[];
	createdAt: Date;
	familyAmount: number;
	giver: ScoredBonusUser;
	reactionCount: number;
	commentCount: number;
	receivers: ScoredBonusUser[];
	// Computed properties
	imageUrl: string;
	detailUrl: string;
};
